import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { defaultLocale, resolveLocale } from '@/locales/config';
import { isLocaleLoaded, loadLocale } from '@/locales/messages';
import type { AppLocale } from '@/locales/types';
import { browserStorage } from '@/utils/browserStorage';

export type { AppLocale } from '@/locales/types';

type LocaleState = {
  locale: AppLocale;
  setLocale: (locale: AppLocale) => void | Promise<void>;
};

let selection = 0;

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: defaultLocale,
      setLocale: (value) => {
        const locale = resolveLocale(value);
        const request = ++selection;
        if (isLocaleLoaded(locale)) {
          set({ locale });
          return;
        }
        return loadLocale(locale).then(
          () => {
            if (request === selection) set({ locale });
          },
          (error: unknown) => {
            if (request === selection) throw error;
          },
        );
      },
    }),
    {
      name: 'react-admin.locale.v1',
      storage: createJSONStorage(() => browserStorage),
      merge: (persisted, current) => ({
        ...current,
        locale: resolveLocale((persisted as Partial<LocaleState> | undefined)?.locale),
      }),
    },
  ),
);
